import React from 'react';
import { Box, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface TextInputProps {
  questionTextKey: string;
  value?: string;
  onChange: (value: string) => void;
}

const TextInput: React.FC<TextInputProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '400px',
        margin: '0 auto',
      }}
    >
      <TextField
        fullWidth
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('common.enter_text')}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            borderRadius: 3,
            height: '56px',
            '& fieldset': {
              border: 'none',
            },
            '&:hover fieldset': {
              border: 'none',
            },
            '&.Mui-focused fieldset': {
              border: 'none',
            },
          },
          '& .MuiOutlinedInput-input': {
            textAlign: 'left',
            pl: 3,
            fontSize: '1rem',
            fontWeight: 500,
            color: 'black',
            '&::placeholder': {
              color: 'rgba(0, 0, 0, 0.6)',
              opacity: 1,
            },
          },
        }}
      />
    </Box>
  );
};

export default TextInput; 